import api from '@/services/api/client';
import { driverService } from '@/services/drivers/driverService';
import type { DriverScheduleDraft, VehicleAssignmentDraft } from '@/types/driverSetupDraft';

export async function applyDriverScheduleDraft(
  driverId: number,
  draft: DriverScheduleDraft
): Promise<void> {
  await driverService.setDriverSchedule(driverId, {
    mode: draft.mode,
    schedule: draft.mode === 'work_hours' ? draft.schedule : undefined,
  });
}

export async function applyVehicleAssignmentDraft(
  driverId: number,
  draft: VehicleAssignmentDraft,
  organizationId: string
): Promise<void> {
  if (draft.kind === 'pick') {
    await driverService.assignDriverToVehicle({
      driverId,
      vehicleId: draft.vehicleId,
      startDate: draft.startDate,
      startTripId: draft.startTripId,
    });
    return;
  }

  if (draft.kind === 'link') {
    await api.post(`/api/device-management/devices/${draft.deviceImei}/move`, {
      targetVehicleId: draft.vehicleId,
      handleExistingDevice: draft.handleExistingDevice,
      notes: 'Kopplad vid skapande av användare',
      // Backdatera monteringen så device_vehicle_history matchar förarkopplingens start
      startDate: draft.startDate,
    });
    await driverService.assignDriverToVehicle({
      driverId,
      vehicleId: draft.vehicleId,
      startDate: draft.startDate,
    });
    return;
  }

  const res = await api.post<{ success: boolean; data: { id?: number; vehicle_id?: number }; error?: string }>(
    '/api/vehicles',
    {
      ...draft.vehicle,
      status: 'ACTIVE',
      organization_id: organizationId,
      is_poolcar: false,
    }
  );
  if (!res.data.success || !res.data.data) {
    throw new Error(res.data.error || 'Kunde inte skapa fordon');
  }
  const created = res.data.data;
  const newVehicleId = parseInt(String(created.vehicle_id ?? created.id), 10);
  if (draft.deviceImei) {
    await api.post(`/api/device-management/devices/${draft.deviceImei}/move`, {
      targetVehicleId: newVehicleId,
      notes: 'Kopplad vid skapande av användare',
      // Backdatera monteringen så device_vehicle_history matchar förarkopplingens start
      startDate: draft.startDate,
    });
  }
  await driverService.assignDriverToVehicle({
    driverId,
    vehicleId: newVehicleId,
    startDate: draft.startDate,
  });
}
